import React from 'react';

import { Portal } from 'src/HOC';

import './popup-content.scss';

interface IPropsPopupContent {
  wrapperClass?: string;
  children?: React.ReactNode;
  visible: boolean;
  title?: string;
  onClickLayout?: () => void;
}

const PopupContent: React.FC<IPropsPopupContent> = ({
  wrapperClass,
  children,
  visible,
  title,
  onClickLayout,
}): JSX.Element | null => {
  if (!visible) {
    return null;
  }

  return (
    <Portal>
      <section className={`popup-wrapper ${wrapperClass}`}>
        <div
          className={`popup-substrate ${wrapperClass}-substrate`}
          onClick={onClickLayout}
        ></div>

        <div className={`popup-body ${wrapperClass}-body`}>
          
          {title && <h2 className="popup-title">{title}</h2>}
          
          <div className={`popup-content ${wrapperClass}-content`}>{children}</div>
        </div>
      </section>
    </Portal>
  );
};

export default PopupContent;
